import s from "./AboutHeroSection.module.scss";

const AboutHeroSection = () => {
  return (
    <section className={s.aboutHeroSection}>
      <h1>OUR JOURNEY</h1>
      <p>
        As a startup, our journey at Aster Information Limited has been defined
        by audacious innovation and resilience. From our inception, we've been
        committed to transforming the realms of Information Management, Data
        Management, IT Consultation, and Software Development. Our story is one
        of continuous growth and learning, as we navigate the challenges and
        opportunities of this dynamic industry with a steadfast commitment to
        excellence and progress.
      </p>
    </section>
  );
};
export default AboutHeroSection;
